import { useTheme } from "@mui/material";
import { createSxStyles } from "../../common/createSxStyles";
import { useAiChatState } from "../AiChatContext";
import { railMargin } from "../../main/rail/Rail.styles";

export const useAiChatDocumentViewerStyles = (isOpen: boolean) => {
    const theme = useTheme();
    // Sits beside the chat rail, so it has to follow the width the user has dragged it to. It catches
    // up when the drag is released; following every frame would need a channel outside React, and a
    // drag with a document open is rare enough not to warrant one.
    const { widthState } = useAiChatState();

    return createSxStyles({
        panel: {
            position: "fixed",
            top: 0,
            left: 0,
            right: widthState.width + railMargin,
            height: "100vh",
            zIndex: 1200,
            display: "flex",
            flexDirection: "column",
            backgroundColor: theme.customPalette.white,
            borderRight: `1px solid ${theme.palette.divider}`,
            boxShadow: "4px 0 12px rgba(0,0,0,0.08)",
            transform: isOpen ? "translateX(0)" : "translateX(-100%)",
            transition: theme.transitions.create(["transform"], {
                easing: theme.transitions.easing.easeInOut,
                duration: 250,
            }),
            pointerEvents: isOpen ? "auto" : "none",
        },
        content: {
            flex: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
        },
    });
};
